import React from 'react'
import { lower } from 'change-case'
import { connect } from 'react-redux'
import { getFormValues, Field, change } from 'redux-form'

import FieldInput, { InputType as type } from 'components/SemanticForm'
import { FileUploadCell } from 'components'

import { AttachmentFormContainer, FieldFileInput } from './styled'

const FieldAttachment = props => {
  const { valueForm } = props

  if(valueForm&&valueForm.attachments){
    var countAttachLine = null
    countAttachLine = Array(Math.ceil(valueForm.attachments.length / 3)).fill(1)
  }

  return (
    <React.Fragment>
      {countAttachLine&&countAttachLine.map((v, i1) => {
        return (
          <AttachmentFormContainer key={i1}>
            {valueForm.attachments.map((dt, i2) => {
              if (Math.floor(i2 / 3) === i1) {
                return (
                  <FieldFileInput className='fieldFileInput' key={i2}>
                    <Field
                      name={`newAttachments.${lower(dt.documentCode)}`}
                      label={dt.title}
                      // require={dt.isRequire}
                      type={type.file}
                      component={FieldInput}
                      containerStyle={{ marginRight: 0 }}
                    />
                    <div style={{ flex: 1 }}>
                      {dt.items&&dt.items.length>0
                        ? dt.items.map((item, i3) => {
                          if(item.deleted) return null
                          else return (
                            <div className='oldFile'>
                              <FileUploadCell
                                key={`${item.originalFilename}${i3}`}
                                fileName={item.originalFilename}
                                fileSize={item.size}
                                deleted={item.deleted}
                                // deletable={!item.isFromVendor}
                                urlPath={item.urlPath}
                                onClickDelete={() => {
                                  if(item.id){
                                    props.change('formPO',`attachments[${i2}].items[${i3}].deleted`,true)
                                  }else{
                                    var clone = [...valueForm.newAttachments[lower(item.documentCode)]]
                                    clone.splice(i3, 1)
                                    props.change('formPO',`newAttachments.${lower(item.documentCode)}`,clone)
                                  }
                                }}
                              />
                            </div>
                          )
                        })
                        : null}
                    </div>
                  </FieldFileInput>
                )
              } else {
                return null
              }
            })}
          </AttachmentFormContainer>
        )
      })}
      {/* <AttachmentFormContainer>
        <FieldFileInput className='fieldFileInput'>
          <Field
            name={'PO04'}
            label={'TOR/Propersal'}
            type={type.file}
            component={FieldInput}
            containerStyle={{ marginRight: 0 }}
          />
          <div style={{ flex: 1 }}>
            {valueForm&&valueForm.attachments
              ? valueForm.attachments[0].items.filter( x => x.documentCode.toLowerCase() === 'PO04' && !x.deleted ).map((item, i3) => (
                    <div className='oldFile'><FileUploadCell
                      key={`${item.originalFilename}${i3}`}
                      fileName={item.originalFilename}
                      fileSize={item.size}
                      deleted={item.deleted}
                      deletable={!item.isFromVendor}
                      urlPath={item.urlPath}
                      onClickDelete={() => {
                        let index = valueForm.attachments[0].items.findIndex(x => x.id === item.id)
                        props.dispatch(change('formPO',`attachments[0].items[${index}].deleted`,true))
                      }}
                    /></div>
                  ))
              : null}
          </div>
        </FieldFileInput>
      </AttachmentFormContainer> */}
    </React.Fragment>
  )
}

const mapStateToProps = state => {
  const valueForm = getFormValues('formPO')(state)
  return {
    grType: state.gr.grType,
    valueForm
  }
}

const mapDispatchToProps = {
  change
}

export default connect(mapStateToProps, mapDispatchToProps)(FieldAttachment)
